export default {"src":"/_next/static/media/building.df11a8df.svg","height":17,"width":16};